export const MINIMAX_H3_CONFIG = {
  type: 'minimaxH3Video',
  modelId: 'minimax/h3',
  modelLabel: 'MINIMAX · H3',
  taskType: 'minimax-h3-video',
  title: '海螺 H3 视频生成',
  icon: '🎥',
  accent: '#a95440',
  soft: '#f7ece8',
  imageLimit: 9,
  videoLimit: 3,
  audioLimit: 3,
  defaultDuration: 5,
  durationOptions: Array.from({ length: 12 }, (_, index) => index + 4),
  defaultAspectRatio: '16:9',
  aspectRatios: ['21:9', '16:9', '4:3', '1:1', '3:4', '9:16'],
  defaultResolution: '768P',
  resolutions: ['768P', '2K'],
  supportsAudio: false,
  referenceHint: '支持最多 9 张参考图、3 个参考视频和 3 个参考音频；音频需搭配图片或视频参考。',
  buildParams: (prompt, images, state, videos = [], audios = []) => ({
    content: [
      { type: 'text', text: prompt },
      ...images.map(url => ({ type: 'image_url', image_url: { url }, role: 'reference_image' })),
      ...videos.map(url => ({ type: 'video_url', video_url: { url }, role: 'reference_video' })),
      ...audios.map(url => ({ type: 'audio_url', audio_url: { url }, role: 'reference_audio' })),
    ],
    resolution: state.resolution,
    duration: state.duration,
    ratio: state.aspectRatio,
    aigc_watermark: false,
  }),
};

export const KLING_O3_REFERENCE_CONFIG = {
  type: 'klingO3ReferenceVideo',
  modelId: 'fal-ai/kling-video/o3/standard/reference-to-video',
  modelLabel: 'KLING O3 · STANDARD',
  taskType: 'kling-o3-reference-video',
  title: '可灵 O3 视频生成',
  icon: '🎞️',
  accent: '#426d9c',
  soft: '#eaf0f6',
  imageLimit: 4,
  videoLimit: 4,
  referenceLimit: 4,
  defaultDuration: 5,
  durationOptions: Array.from({ length: 13 }, (_, index) => index + 3),
  defaultAspectRatio: '16:9',
  aspectRatios: ['16:9', '9:16', '1:1'],
  defaultResolution: 'Standard',
  resolutions: ['Standard'],
  supportsAudio: true,
  defaultGenerateAudio: true,
  referenceHint: '支持图片和视频参考，合计最多 4 个；图片用 @Image1，视频元素用 @Element1 引用。',
  buildParams: (prompt, images, state, videos = []) => ({
    prompt,
    image_urls: images,
    ...(videos.length ? { elements: videos.map(videoUrl => ({ video_url: videoUrl })) } : {}),
    duration: String(state.duration),
    aspect_ratio: state.aspectRatio,
    generate_audio: state.generateAudio,
    shot_type: 'customize',
  }),
};

export const GEMINI_OMNI_FLASH_CONFIG = {
  type: 'geminiOmniFlashVideo',
  modelId: 'google/gemini-omni-flash',
  modelLabel: 'GOOGLE · OMNI FLASH',
  taskType: 'gemini-omni-flash-video',
  title: 'Gemini 极速视频生成',
  icon: '⚡',
  accent: '#6e5a96',
  soft: '#f0edf5',
  imageLimit: 5,
  defaultDuration: 5,
  durationOptions: Array.from({ length: 8 }, (_, index) => index + 3),
  defaultAspectRatio: '16:9',
  aspectRatios: ['16:9', '9:16'],
  defaultResolution: '720P',
  resolutions: ['720P'],
  supportsAudio: false,
  referenceHint: '连接 1–5 张图片后自动进入参考图模式；不连接图片时使用文生视频模式。',
  buildParams: (prompt, images, state) => ({
    prompt,
    duration: state.duration,
    resolution: '720P',
    aspect_ratio: state.aspectRatio,
    ...(images.length ? { reference_image_urls: images } : {}),
  }),
};

export const SUPER_SEED_2_LITE_CONFIG = {
  type: 'superSeed2LiteVideo',
  modelId: 'st-ai/super-seed2-lite',
  modelLabel: 'SEEDANCE 2.5 · OMNI',
  taskType: 'super-seed2-lite-video',
  title: 'Seedance 2.5 视频生成',
  icon: '🎬',
  accent: '#337563',
  soft: '#e9f2ef',
  imageLimit: 30,
  videoLimit: 10,
  audioLimit: 10,
  defaultDuration: 6,
  durationOptions: Array.from({ length: 27 }, (_, index) => index + 4),
  defaultAspectRatio: '16:9',
  aspectRatios: ['16:9', '21:9', '9:16', '4:3', '3:4', '1:1'],
  defaultResolution: '480p',
  resolutions: ['480p', '720p'],
  supportsAudio: false,
  referenceHint: '支持图片、视频和音频参考；提示词中可用【@图片1】、【@视频1】、【@音频1】引用对应素材。',
  buildParams: (prompt, images, state, videos = [], audios = []) => ({
    model: 'Seedance_2.5',
    functionMode: 'omini',
    prompt,
    image_files: images,
    ...(videos.length ? { video_files: videos } : {}),
    ...(audios.length ? { audio_files: audios } : {}),
    duration: state.duration,
    ratio: state.aspectRatio,
    resolution: state.resolution,
  }),
};
